import { NgModule }      from '@angular/core';
import { CommonModule } from '@angular/common';

import { TravellerComponent } from './traveller.component';
import { BtnModule } from '../../ui_button/btn.module';
import { PipesModule } from '../../pipes/pipes.module';
import { DatePipeModule } from '../../date/date.module';
import { CardModule } from '../../ui_card/card.module';
import { UIModule } from '../../ui/ui.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        PipesModule,
        UIModule,
        CardModule,
        DatePipeModule,
        FontAwesomeModule,
    ],
    declarations: [
        TravellerComponent,
    ],
    exports: [
        TravellerComponent,
    ],
})
export class TravellerComponentModule {  }